import React , {useState, useEffect, useRef} from 'react';
import { Container, Form, Button, Row, Col, Card, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey } from '@fortawesome/free-solid-svg-icons';
import { useDispatch,useSelector } from 'react-redux';
import { useNavigate,Link, useParams, useLocation } from 'react-router-dom';
import { useVerifySignupMutation, useResendOtpMutation } from '../../features/auth/authApiSlice';
import { setAuthLoading, setAuthError } from '../../features/auth/authSlice';
import { selectAuthError, selectAuthStatus } from '../../features/auth/authSlice';

const Verifyotp = () => {
  const location = useLocation();

  // ✅ registrationData को useState के रूप में रखें
  const [registrationData, setRegistrationData] = useState(null);
  const dataInitialized = useRef(false); // यह ट्रैक करने के लिए कि डेटा को एक बार इनिशियलाइज़ किया गया है

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [verifySignup] = useVerifySignupMutation();
  const [resendOtp] = useResendOtpMutation();
  const authStatus = useSelector(selectAuthStatus);
  const authError = useSelector(selectAuthError);

  const [formData, setFormData] = useState({
    otp: '',
    errors: {},
  });

  const [resendTimer, setResendTimer] = useState(0);
  const [canResend, setCanResend] = useState(false);

  // ✅ डेटा को केवल एक बार location.state से सेट करें
  useEffect(() => {
    // ✅ वेरी अर्ली लॉगिंग ताकि हम location और location.state देख सकें
    console.log('Verifyotp (Initial Render Check): Full location object:', location);
    console.log('Verifyotp (Initial Render Check): Directly checking location.state:', location.state);

    if (location.state && !dataInitialized.current) {
      setRegistrationData(location.state);
      dataInitialized.current = true; // Flag as initialized
      console.log('Verifyotp (Initial Setup): location.state used to set registrationData:', location.state);
    } else if (!location.state && !registrationData && !authError) {
        // यदि component माउंट होता है और कोई state नहीं है, तो तुरंत पुनर्निर्देशित करें
        console.warn('Verifyotp (Initial Setup): No location.state found on mount. Redirecting.');
        dispatch(setAuthError('पंजीकरण डेटा उपलब्ध नहीं है। कृपया पुनः पंजीकरण करें।'));
        // setTimeout(() => { // कुछ समय दें ताकि लॉग दिखाई दें (डिबगिंग के लिए)
            navigate('/registration', { replace: true });
        // }, 500);
    }
  }, [location.state, registrationData, navigate, dispatch, authError]);


  // Resend timer effect
  useEffect(() => {
    // कंपोनेंट माउंट होने पर या रजिस्ट्रेशन डेटा आने पर टाइमर शुरू करें
    if (registrationData && resendTimer === 0) { // केवल तभी शुरू करें जब टाइमर 0 हो
      setResendTimer(60);
    }
  }, [registrationData]); // registrationData पर निर्भर करें ताकि जब यह उपलब्ध हो तो टाइमर शुरू हो

  useEffect(() => {
    let timerInterval;
    if (resendTimer > 0) {
      setCanResend(false);
      timerInterval = setInterval(() => {
        setResendTimer((prevTime) => prevTime - 1);
      }, 1000);
    } else {
      setCanResend(true);
      clearInterval(timerInterval);
    }

    return () => clearInterval(timerInterval); // Cleanup on unmount
  }, [resendTimer]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
      errors: { ...prevData.errors, [name]: '' },
    }));
    dispatch(setAuthError(null));
  };

  const validateForm = () => {
    let newErrors = {};
    let isValid = true;

    if (!formData.otp.trim()) {
      newErrors.otp = 'OTP आवश्यक है!';
      isValid = false;
    } else if (!/^[0-9]{6}$/.test(formData.otp)) {
      newErrors.otp = 'कृपया एक वैध 6-अंकीय OTP दर्ज करें।';
      isValid = false;
    }

    setFormData((prevData) => ({ ...prevData, errors: newErrors }));
    return isValid;
  };

  const handleRegistration = async (e) => {
    e.preventDefault();
    dispatch(setAuthError(null));

    if (!validateForm()) {
      return;
    }

    // ✅ सुनिश्चित करें कि registrationData और उसकी आवश्यक प्रॉपर्टीज मौजूद हैं
    if (!registrationData || !registrationData.verifyUserToken || !registrationData.user || (!registrationData.user.email)) {
      console.error('handleRegistration: Missing critical registration data.');
      dispatch(setAuthError('सत्यापन के लिए डेटा उपलब्ध नहीं है। कृपया पंजीकरण प्रक्रिया पुनः प्रारंभ करें।'));
      navigate('/registration'); // पंजीकरण पृष्ठ पर पुनर्निर्देशित करें
      return;
    }

    dispatch(setAuthLoading('loading'));

    try {
      const payload = {
        token: formData.otp, // ✅ 'otp' को 'token' में बदला गया ताकि बैकएंड से मेल खा सके
        verifyUserToken: registrationData.verifyUserToken,
      };

      console.log('OTP Verification Request Payload:', payload); // लॉग पेलोड
      const response = await verifySignup(payload).unwrap();

      console.log('OTP Verification Response:', response);

      if (response.success) {
        dispatch(setAuthLoading('succeeded'));
        setFormData({ otp: '', errors: {} });
        navigate('/verifysuccess');
      } else {
        dispatch(setAuthError(response.message || 'OTP सत्यापन विफल रहा। कोई विशिष्ट संदेश नहीं।'));
        dispatch(setAuthLoading('failed'));
      }
    } catch (err) {
      console.error('OTP सत्यापन में त्रुटि:', err);
      let errorMessage = 'OTP सत्यापन के दौरान एक अप्रत्याशित त्रुटि हुई।';

      if (err?.data?.message) {
          errorMessage = err.data.message;
      } else if (err?.message) {
          errorMessage = err.message;
      } else if (err?.error) {
          errorMessage = err.error;
      }
      dispatch(setAuthError(errorMessage));
      dispatch(setAuthLoading('failed'));
    }
  };

  const handleResendOtp = async () => {
    // ✅ सुनिश्चित करें कि registrationData और उसकी आवश्यक प्रॉपर्टीज मौजूद हैं
    if (!registrationData || !registrationData.user || (!registrationData.user.email && !registrationData.user.mobile)) {
      console.error('handleResendOtp: Missing critical registration data.');
      dispatch(setAuthError('OTP पुनः भेजने के लिए पंजीकरण डेटा गुम है।'));
      navigate('/registration'); // पंजीकरण पृष्ठ पर पुनर्निर्देशित करें
      return;
    }

    dispatch(setAuthError(null));
    dispatch(setAuthLoading('loading'));

    try {
      const payload = {};
      if (registrationData.user.email) {
        payload.email = registrationData.user.email;
      } else if (registrationData.user.mobile) {
        payload.mobile = registrationData.user.mobile;
      }

      console.log('Resending OTP with payload:', payload);
      const response = await resendOtp(payload).unwrap();

      console.log('Resend OTP Response:', response);

      if (response.success) {
        // ✅ महत्वपूर्ण: नए verifyUserToken के साथ registrationData को अपडेट करें
        setRegistrationData(prevData => ({
            ...prevData,
            verifyUserToken: response.verifyUserToken // ✅ नया JWT यहां से अपडेट हो रहा है
        }));
        
        dispatch(setAuthLoading('succeeded'));
        dispatch(setAuthError(response.message || 'नया OTP सफलतापूर्वक भेज दिया गया है!'));
        setResendTimer(60);
        setCanResend(false);
      } else {
        dispatch(setAuthError(response.message || 'OTP पुनः भेजने में विफल रहा।'));
        dispatch(setAuthLoading('failed'));
      }
    } catch (err) {
      console.error('OTP पुनः भेजने में त्रुटि:', err);
      let errorMessage = 'OTP पुनः भेजने के दौरान एक अप्रत्याशित त्रुटि हुई।';
      if (err?.data?.message) {
          errorMessage = err.data.message;
      } else if (err?.message) {
          errorMessage = err.message;
      } else if (err?.error) {
          errorMessage = err.error;
      }
      dispatch(setAuthError(errorMessage));
      dispatch(setAuthLoading('failed'));
    }
  };

  const isSubmitting = authStatus === 'loading';

  // यदि registrationData अभी तक लोड नहीं हुआ है, तो लोडिंग स्थिति दिखाएं
  if (!registrationData) {
    return (
      <div className="auth-container-new mt-5">
        <Container>
          <Row className="justify-content-md-center">
            <Col xs={12} md={4}>
              <Card className="mt-5">
                <Card.Body>
                  <Card.Title className="text-center site-color-dark-red h2 mb-4">लोड हो रहा है...</Card.Title>
                  <div className='text-center'>
                    <Spinner animation="border" role="status" />
                    <p className="mt-3">पंजीकरण डेटा लोड हो रहा है या गुम है।</p>
                    <p className="text-muted">यदि यह कुछ सेकंड से अधिक रहता है, तो कृपया पुनः पंजीकरण करें।</p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div className="auth-container-new mt-5">
      <Container>
        <Row className="justify-content-md-center">
          <Col xs={12} md={4}>
            <Card className="mt-5">
              <Card.Body>
                <Card.Title className="text-center site-color-dark-red h2 mb-4">OTP सत्यापित करें</Card.Title>
                <div className='text-center mb-4'>
                  {registrationData?.message || 'कृपया OTP के लिए अपना ईमेल/मोबाइल जांचें और सत्यापित करें।'}
                  {registrationData.user.email && <p>को भेजा गया: {registrationData.user.email}</p>}
                  {!registrationData.user.email && registrationData.user.mobile && <p>को भेजा गया: {registrationData.user.mobile}</p>}
                </div>
                <Form onSubmit={handleRegistration}>
                  <Form.Group controlId="formBasicOtp" className="form-group">
                    <FontAwesomeIcon icon={faKey} className="form-icon" />
                    <Form.Control
                      type="text"
                      placeholder="OTP दर्ज करें"
                      name="otp"
                      value={formData.otp}
                      onChange={handleInputChange}
                      disabled={isSubmitting}
                      maxLength={6}
                    />
                  </Form.Group>
                  {formData.errors.otp && <span className="error">{formData.errors.otp}</span>}
                  <div className="form-group">
                    <Button variant="primary" type="submit" className="form-btn" disabled={isSubmitting}>
                      सत्यापित करें {isSubmitting ? (
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                      ) : null}
                    </Button>
                  </div>
                </Form>

                <div className="text-center mt-3">
                  {authError && <span className="error">{authError}</span>}
                </div>

                <div className="text-center mt-3">
                    <Button
                        variant="link"
                        onClick={handleResendOtp}
                        disabled={!canResend || isSubmitting}
                        className="p-0 border-0"
                    >
                        {resendTimer > 0 ? (
                            `OTP पुनः भेजें ${resendTimer}s में`
                        ) : (
                            'OTP पुनः भेजें'
                        )}
                        {isSubmitting && !canResend ? (
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="ms-2"
                            />
                        ) : null}
                    </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Verifyotp;
